module.exports = __webpack_public_path__ + "img/ev.53210bb1.svg";